import React, {Component} from "react";
import {connect} from "react-redux";
import logo from "../../images/logo-white.png"
import {history} from "../../history/History";
import FooterLanding from "./FooterLanding";

class NotFound extends Component {

    constructor(props) {
        super(props)

        this.state = {
            mobileHeaderOpenStatus: 0,
            heightStyle: undefined
        }
    }

    toggleMobileMenu = () => {
        let status = this.state.mobileHeaderOpenStatus;
        this.setState({
            mobileHeaderOpenStatus: status === 2 ? 0 : 2
        });
    }

    gotoSumMenu = (id) => {
        document.getElementById(id).scrollIntoView({
            behavior: 'smooth'
        })
        if (this.state.mobileHeaderOpenStatus === 2)
            this.setState({
                mobileHeaderOpenStatus: 0
            });
    }

    render() {
        return (
            <div>
                <header className={"ReactStickyHeader_root is-sticky"}>
                    <div className="ReactStickyHeader_fixed">
                        <nav className="navbar-custom sticky sticky-dark  navbar navbar-expand-lg fixed-top">
                            <div className="container">
                                <img src={logo} alt="" className="logo-landing"/>
                                <a href="/"
                                   className="logo text-uppercase navbar-brand white-text">Tutorfest
                                </a>
                                <button
                                    onClick={this.toggleMobileMenu}
                                    aria-label="Toggle navigation"
                                    className="navbar-toggler">
                                    <i className="icon-menu"/>
                                </button>
                                <div id="navbarCollapse"
                                     className={(this.state.mobileHeaderOpenStatus === 0 ?
                                         "collapse" : (this.state.mobileHeaderOpenStatus === 1 ?
                                             "collapsing" : "collapse show")) + " navbar-collapse"}
                                     style={this.state.heightStyle ? {height: this.state.heightStyle + 'px'} : {}}
                                >
                                    <div data-nav="list" className="navbar-collapse">
                                        <ul id="mySidenav" className="navbar-center navbar-nav">
                                            <li className="nav-item active">
                                                <button
                                                    onClick={() => history.push("/")}
                                                    className="header-item nav-link active"> Home
                                                </button>
                                            </li>
                                        </ul>
                                        <div className="nav-button ms-auto">
                                            <ul className="navbar-end navbar-nav">
                                                <li>
                                                    <button onClick={() => history.push("/hom/login")}
                                                            className="btn mr-2 btn-primary pink navbar-btn btn-rounded waves-effect waves-light ">
                                                        Login
                                                    </button>
                                                </li>
                                                <li className="show-desktop">
                                                    <button onClick={() => history.push("/hom/register")}
                                                            className="btn btn-primary navbar-btn btn-rounded waves-effect waves-light black-text">
                                                        Sign Up
                                                    </button>
                                                </li>
                                                <li className="show-mobile mt-3">
                                                    <button
                                                        className="btn btn-primary navbar-btn btn-rounded waves-effect waves-light black-text">
                                                        Sign Up
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>

                    <div className="ReactStickyHeader_foreground" style={{opacity: 1}}/>
                </header>
                <section className="section" style={{margin: '45px 0 100px'}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-2"/>
                            <div className="col-sm-8">
                                <h1 className="section-title text-center">404 Not found</h1>

                                <div className="mt-5 text-center">
                                    <button
                                        onClick={() => history.push("/")}
                                        className="btn btn-primary navbar-btn btn-rounded waves-effect waves-light pink">
                                        Go Back To Home
                                    </button>
                                </div>
                            </div>
                            <div className="col-sm-2"/>
                        </div>
                    </div>
                </section>
                <FooterLanding/>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(NotFound)
